import { render, staticRenderFns } from "./Departamentos.vue?vue&type=template&id=345e4cb5&scoped=true&lang=pug&"
import script from "./Departamentos.vue?vue&type=script&lang=js&"
export * from "./Departamentos.vue?vue&type=script&lang=js&"
import style0 from "./Departamentos.vue?vue&type=style&index=0&id=345e4cb5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e4cb5",
  null
  
)

export default component.exports